// 开发环境
const isDev = process.env.NODE_ENV === 'development'

// API 基础路径
export const baseURL = isDev ? 'http://localhost:8000' : 'https://api.example.com'

// 请求超时时间
export const timeout = 10000

// 其他配置项
export const config = {
  // 调试模式
  debug: isDev,
  // 版本号
  version: '1.0.0',
  // 缓存前缀
  storagePrefix: 'app_',
  // 请求重试次数
  retryCount: 3
} 